import guides from './guides.json';
import calculators from './calculators.json';

export const shopifyPages = [...guides, ...calculators];
export const shopifySummaries = shopifyPages.map(
  ({ slug, title, description, category, tool }) => ({
    slug,
    title,
    description,
    category,
    toolLabel: tool.title
  })
);
